<section class="dynamic-collapse">
	<section class="dynamic-collapse-header-toggle" (click)="statusDynamicCollapse=!statusDynamicCollapse"
			 [ngClass]="statusDynamicCollapse ? 'dynamic-collapse-header-collapsed' : ''">
		<h3>Gendry Baratheon</h3>
		<div class="manage-buttons">
			<div class="edit-btn">
				<input type="button" class="btn btn-primary primary-sml-btn" value="edit">
				<i class="fa fas fa-pencil-alt"></i>
			</div>
			<div class="delete-btn">
				<input type="button" class="btn btn-primary primary-sml-btn" value="Cancel">
				<i class="fa fas fa-trash"></i>
			</div>
			<div class="chevron-down">
				<i class="fa fas fa-chevron-down"
				   [ngClass]="statusDynamicCollapse ? 'chevron-collapsed' : ''">
				</i>
			</div>
		</div>
	</section>
	<section class="dynamic-collapse-main" [ngClass]="statusDynamicCollapse ? 'dynamic-collapse-main-collapsed' : ''">
		<section class="dynamic-collapse-content">
			<section class="category-rights">
				<div class="category">Assets</div>
				<div class="rights">
					<i class="fa fas fa-trash"></i>
					<div class="name-rights">Contributor</div>
				</div>
			</section>
		</section>
	</section>
</section>
